import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Function to remove lazy loading from images in swiper slides
function removeLazyLoading( container ) {
  const slides = container.querySelectorAll( '.swiper-slide' );
  slides.forEach( slide => {
    const images = slide.querySelectorAll( 'img' );
    images.forEach( img => {
      if ( img.loading === 'lazy' ) {
        img.loading = 'eager';
      }
    } );
  } );
}

document.querySelectorAll( '.e-stn--banner-with-image-slider' ).forEach( initCarousel );

function cloneSlides( container, minSlides = 10 ) {
  const wrapper = container.querySelector( '.swiper-wrapper' );
  if ( !wrapper ) return;
  
  const slides = wrapper.querySelectorAll( '.swiper-slide' );

  if ( slides.length < minSlides ) {
    const clonesNeeded = minSlides - slides.length;
    
    for ( let i = 0; i < clonesNeeded; i++ ) {
      const originalSlide = slides[i % slides.length];
      const clone = originalSlide.cloneNode( true );
      wrapper.appendChild( clone );
    }
  }
}

function initCarousel( container ) {
  const swiperParams = getSwiperParams( container );
  if ( !swiperParams ) return;

  // Remove lazy loading from images
  removeLazyLoading( container );

  const swiper = createSwiper( container );
  
  setTimeout( () => {
    const calculateRequiredClones = () => {
      const viewportWidth = window.innerWidth;
      const wrapper = container.querySelector( '.swiper-wrapper' );
      if ( !wrapper ) return 30;
      
      const originalSlides = wrapper.querySelectorAll( '.swiper-slide' );
      if ( originalSlides.length === 0 ) return 30;
      
      let originalWidth = 0;
      originalSlides.forEach( slide => {
        originalWidth += slide.offsetWidth;
      } );
      
      // Ensure we have enough slides to cover at least 6x viewport width for seamless looping
      const setsNeeded = Math.ceil( ( viewportWidth * 6 ) / originalWidth );
      const totalSlidesNeeded = originalSlides.length * setsNeeded;
      
      return Math.max( 50, totalSlidesNeeded );
    };

    const requiredClones = calculateRequiredClones();
    cloneSlides( container, requiredClones );
    
    // Remove lazy loading from all images including clones
    removeLazyLoading( container );
    
    setTimeout( () => {
      createKeyframes( swiper, container );
      setupAutoplayHandlers( swiper );
    }, 50 );
  }, 100 );
}

function createKeyframes( swiper, container ) {
  const calculateTotalWidth = () => {
    const slides = swiper.el.querySelectorAll( '.swiper-slide' );
    let totalWidth = 0;
    
    slides.forEach( slide => {
      totalWidth += slide.offsetWidth;
    } );
    
    return totalWidth;
  };

  const totalWidth = calculateTotalWidth();
  const viewportWidth = swiper.el.offsetWidth;
  
  let speedMultiplier;
  
  if ( window.innerWidth <= 480 ) {
    speedMultiplier = 8;
  } else if ( window.innerWidth <= 768 ) {
    speedMultiplier = 8;
  } else if ( window.innerWidth <= 1024 ) {
    speedMultiplier = 12;
  } else if ( window.innerWidth <= 1440 ) {
    speedMultiplier = 22;
  } else {
    speedMultiplier = 28;
  }
  
  // Use simple half-width approach for reliable looping
  const finalLoopDistance = totalWidth / 2;
  
  // Calculate duration based on loop distance
  const duration = ( finalLoopDistance / viewportWidth ) * speedMultiplier;
  
  // Remove existing style if it exists to force update
  const existingStyle = document.getElementById( `swiper-style-${container.dataset.swiperId}` );
  if ( existingStyle ) {
    existingStyle.remove();
  }
  
  const style = document.createElement( 'style' );
  style.id = `swiper-style-${container.dataset.swiperId}`;
  style.textContent = `
    @keyframes swiper-marquee-${container.dataset.swiperId} {
      0% { transform: translateX(0) translateZ(0); }
      100% { transform: translateX(-${finalLoopDistance}px) translateZ(0); }
    }
    
    .swiper-wrapper-marquee-${container.dataset.swiperId} {
      animation: swiper-marquee-${container.dataset.swiperId} ${duration}s linear infinite;
      animation-play-state: running;
      will-change: transform;
      backface-visibility: hidden;
      transform: translateZ(0);
      display: flex !important;
      align-items: center;
      animation-timing-function: linear;
      animation-fill-mode: both;
    }
    
    .swiper-wrapper-marquee-${container.dataset.swiperId}.paused {
      animation-play-state: paused;
    }
    
    .swiper-wrapper-marquee-${container.dataset.swiperId} .swiper-slide {
      flex-shrink: 0;
      width: auto !important;
      display: inline-block;
    }
    
    .swiper-wrapper-marquee-${container.dataset.swiperId} {
      position: relative !important;
      left: 0 !important;
      top: 0 !important;
    }
  `;
  document.head.appendChild( style );

  // Apply marquee animation to wrapper
  const swiperWrapper = swiper.el.querySelector( '.swiper-wrapper' );
  
  // Remove existing class and re-add to force refresh
  swiperWrapper.classList.remove( `swiper-wrapper-marquee-${container.dataset.swiperId}` );
  
  // Force a reflow to prevent animation glitches
  swiperWrapper.offsetHeight; //NOSONAR
  
  setTimeout( () => {
    swiperWrapper.classList.add( `swiper-wrapper-marquee-${container.dataset.swiperId}` );
  }, 10 );
  
  // Disable Swiper's internal positioning
  swiperWrapper.style.position = 'relative';
  swiperWrapper.style.left = '0';
  swiperWrapper.style.top = '0';
}

function getSwiperParams( container ) {
  const swiperDataEl = container.querySelector( '[data-swiper]' );
  if ( !swiperDataEl ) return null;

  try {
    return JSON.parse( swiperDataEl.getAttribute( 'data-swiper' ) );
  } catch ( e ) {
    return null;
  }
}

function createSwiper( container ) {
  const swiper = new Swiper( container.querySelector( '.swiper' ), {
    autoplay: false, // Disable Swiper's autoplay completely
    loop: false, // Disable loop to prevent conflicts
    slidesPerView: 'auto',
    allowTouchMove: false,
    longSwipesRatio: 0.1,
    speed: 0, // No transition speed
    breakpoints: {
      340: { speed: 0 },
      768: { speed: 0 },
      992: { speed: 0 },
      1200: { speed: 0 },
    },
  } );

  // Add unique ID to container for unique keyframes
  if ( !container.dataset.swiperId ) {
    // Use timestamp + random suffix for reliable unique IDs
    const timestamp = Date.now().toString( 36 );
    const randomSuffix = Math.floor( Math.random() * 1000 ).toString( 36 ); //NOSONAR
    container.dataset.swiperId = `swiper-${timestamp}-${randomSuffix}`;
  }

  // Keyframes will be created after cloning in initCarousel

  return swiper;
}

function setupAutoplayHandlers( swiper ) {
  const swiperWrapperEl = swiper.el.querySelector( '.swiper-wrapper' );
  
  // Keyframe animation controls
  const pauseAnimation = () => {
    swiperWrapperEl.classList.add( 'paused' );
  };
  
  const resumeAnimation = () => {
    swiperWrapperEl.classList.remove( 'paused' );
  };

  // Hover effects for banner slider
  const handleTogglePlay = toggle => {
    if ( toggle === 'in' ) {
      pauseAnimation();
    } else if ( toggle === 'out' ) {
      resumeAnimation();
    }
  };

  const debouncedToggle = debounce( handleTogglePlay, 100 );

  setTimeout( () => {
    swiper.el.querySelectorAll( '.swiper-slide a' ).forEach( link => {
      link.addEventListener( 'pointerenter', () => debouncedToggle( 'in' ) );
      link.addEventListener( 'pointerleave', () => debouncedToggle( 'out' ) );
    } );
  }, 150 );
}

function debounce( func, delay ) {
  let timer;
  return ( ...args ) => {
    if ( timer ) clearTimeout( timer );
    timer = setTimeout( () => func( ...args ), delay );
  };
}
